import React, { useState, useCallback, useRef, useEffect } from "react";
import { Table } from "antd";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import update from "immutability-helper";
import { Offcanvas } from "react-bootstrap";
import useApiServices from "../../utils/useApiServices";
import {
  DISABLE_PAYOUT_RULE,
  DISABLE_RULE,
  GET_AMOUNT_RULES,
  GET_PAYOUT_AMOUNT_RULES,
  UPDATE_MID_RULES,
  UPDATE_MID_PAYOUT_RULES,
  GET_WHITELIST_AMOUNT_RULES,
  UPDATE_WHITELIST_MID_RULES,
  DISABLE_WHITELIST_RULE,
  UPDATE_MID_RULE2S,
} from "../../utils/constant";
import swal from "sweetalert";

const ShuffleRules = ({
  showRule,
  setShowRule,
  mid,
  Id,
  viewOnly,
  type,
  getAllMerchantsWithTheirRules,
}) => {
  const [data, setData] = useState([]);
  const [viewSid, setViewSid] = useState(false);
  const [sidData, setSidData] = useState([]);

  const {
    apiCallFnforGet,
    apiCallFnforPost,
    apiCallFnforPut,
    apiCallFnforDelete,
  } = useApiServices();

  const FetchDataForRules = async (type) => {
    const response = await apiCallFnforGet(
      type === "Payout"
        ? GET_PAYOUT_AMOUNT_RULES + mid
        : type === "Frm"
        ? GET_AMOUNT_RULES + mid
        : `${GET_WHITELIST_AMOUNT_RULES}/${mid}`
    );

    if (response?.statusCode === 200) {
    }
    const finalRes = response?.data?.map((item, index) => ({
      id: item?.id,
      ruleId: item?.ruleId ?? 0,
      routingId: item?.routingId ?? 0,
      ruleName: item?.ruleName ?? 0,
      prority: index + 1,
      domain: item.domain,
      mid: item.mid,
      processor: item.processor,
      remarkMessage: item.remarkMessage,
      payoutMasterDataId: item?.payoutMasterDataId,
      requestMode: item.requestMode,
      sid: item.sid,
      status: item.isDenied,
      txnMaxAmount: item.txnMaxAmount,
      txnMinAmount: item.txnMinAmount,
    }));

    setData(finalRes);
  };

  useEffect(() => {
    FetchDataForRules(type);
  }, [showRule]);

  const updateRules = async () => {
    try {
      const payloadForPayout = data.map((item) => ({
        prority: null,
        domain: item.domain,
        mid: item.mid,
        processor: item.processor,
        remarkMessage: item.remarkMessage,
        payoutMasterDataId: item.payoutMasterDataId,
        sid: item.sid,
        isDenied: item.status ? true : false,
        txnMaxAmount: item.txnMaxAmount,
        txnMinAmount: item.txnMinAmount,
      }));
      const payload = {
        prority: 0,
        domain: "",
        mid: data[0].mid,
        id: 0,
        processor: data[0].processor,
        requestMode: data[0].requestMode,
        sidList: data.map((item) => item?.routingId),
        isDenied: data[0].status ? true : false,
        txnMaxAmount: data[0].txnMaxAmount,
        txnMinAmount: data[0].txnMinAmount,
      };

      const payload2 = data.map((item) => ({
        prority: null,
        domain: item.domain,
        mid: item.mid,
        processor: item.processor,
        remarkMessage: item.remarkMessage,
        requestMode: item.requestMode,
        sid: item.sid,
        isDenied: item.status ? true : false,
        txnMaxAmount: item.txnMaxAmount,
        txnMinAmount: item.txnMinAmount,
      }));
      const payloadForWhitelist = {
        prority: 0,
        domain: data[0].domain ?? "",
        mid: data[0].mid,
        processor: data[0].processor,
        id: 0,
        requestMode: data[0].requestMode,
        sidList: data.map((item) => item?.routingId),
        isDenied: !!data[0].status,
        txnMaxAmount: data[0].txnMaxAmount,
        txnMinAmount: data[0].txnMinAmount,
      };

      swal({
        title: "Alert",
        text: `Are you sure, you want to Update?`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDisable) => {
        if (willDisable) {
          let response;

          if (type === "Payout") {
            response = await apiCallFnforPost(
              UPDATE_MID_PAYOUT_RULES,
              payloadForPayout
            );
          } else if (type === "Frm") {
            response = await apiCallFnforPut(UPDATE_MID_RULE2S, payload);
          } else {
            response = await apiCallFnforPut(
              UPDATE_WHITELIST_MID_RULES,
              payloadForWhitelist
            );
          }
          if (response.statusCode === 200) {
            swal({
              title: "Success",
              text: response.message,
              icon: "success",
            });
            setTimeout(() => {
              getAllMerchantsWithTheirRules();
            }, 2000);
          } else {
            swal({
              title: "Alert",
              text: response.message,
              icon: "error",
            });
          }
        } else {
        }
      });
    } catch (error) {
      swal({
        title: "Alert",
        text: error,
        icon: "error",
      });
    }
  };

  const DraggableBodyRow = ({
    index,
    moveRow,
    className,
    style,
    ...restProps
  }) => {
    const ref = useRef();
    const [{ isOver, dropClassName }, drop] = useDrop({
      accept: "DraggableBodyRow",
      collect: (monitor) => {
        const { index: dragIndex } = monitor.getItem() || {};
        if (dragIndex === index) {
          return {};
        }
        return {
          isOver: monitor.isOver(),
          dropClassName:
            dragIndex < index ? " drop-over-downward" : " drop-over-upward",
        };
      },
      drop: (item) => {
        moveRow(item.index, index);
      },
    });

    const [, drag] = useDrag({
      type: "DraggableBodyRow",
      item: { index },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    });

    drop(drag(ref));

    return (
      <tr
        ref={ref}
        className={`${className}${isOver ? dropClassName : ""}`}
        style={{ cursor: "move", ...style }}
        {...restProps}
      ></tr>
    );
  };

  const columns = [
    {
      title: "MID",
      dataIndex: "mid",
      key: "mid",
    },
    {
      title: "Domain",
      dataIndex: "domain",
      key: "domain",
    },
    {
      title: "Processor",
      dataIndex: "processor",
      key: "processor",
    },

    {
      title: "Request Mode",
      dataIndex: "requestMode",
      key: "requestMode",
    },

    {
      title: "Rule Name",
      dataIndex: "ruleName",
      key: "ruleName",
    },

    {
      title: "Txn Min Amount",
      dataIndex: "txnMinAmount",
      key: "txnMinAmount",
    },
    {
      title: "Txn Max Amount",
      dataIndex: "txnMaxAmount",
      key: "txnMaxAmount",
    },
    {
      title: "Action",
      dataIndex: type === "Payout" ? "id" : "ruleId",
      key: type === "Payout" ? "id" : "ruleId",
      render: (id) =>
        !viewOnly && (
          <div className="w-100 d-flex align-items-center gap-2">
            <button
              className="btn btn-danger"
              onClick={() => handleRuleDelete(id)}
            >
              Delete{" "}
            </button>
          </div>
        ),
    },
  ];

  const handleRuleDelete = async (id) => {
    try {
      swal({
        title: "Alert",
        text: `Are you sure, you want to Delete this rule?`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDisable) => {
        if (willDisable) {
          let response;

          if (type === "Payout") {
            response = await apiCallFnforDelete(DISABLE_PAYOUT_RULE + id);
          } else if (type === "Frm") {
            response = await apiCallFnforDelete(DISABLE_RULE + id);
          } else {
            response = await apiCallFnforPut(DISABLE_WHITELIST_RULE + id);
          }
          if (response.statusCode === 200) {
            swal({
              title: "Success",
              text: response.message,
              icon: "success",
            });
            FetchDataForRules(type);
          } else {
            swal({
              title: "Alert",
              text: response.message,
              icon: "error",
            });
          }
        } else {
        }
      });
    } catch (error) {
      swal({
        title: "Alert",
        text: error,
        icon: "error",
      });
    }
  };

  const offcanvasStyle = {
    width: "90vw", // Set width to 70vw
  };

  const [show, setShow] = useState(true);

  const handleClose = () => {
    setShowRule(false);
  };

  const moveRow = useCallback(
    (dragIndex, hoverIndex) => {
      const dragRow = data[dragIndex];
      const newData = update(data, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragRow],
        ],
      });

      const updatedData = newData.map((item, index) => ({
        ...item,
        // prority: index + 1,
      }));

      setData(updatedData);
    },
    [data]
  );

  const components = {
    body: {
      row: (props) => <DraggableBodyRow {...props} moveRow={moveRow} />,
    },
  };

  return (
    <>
      <Offcanvas
        show={showRule}
        onHide={handleClose}
        placement="end"
        style={offcanvasStyle}
        backdrop="static"
        keyboard={false}
      >
        <div className="d-flex justify-content-start align-items-center">
          <Offcanvas.Header closeButton></Offcanvas.Header>
          <h5
            class="offcanvas-title  fs-2 text-dark fw-bold"
            id="offcanvasLabel"
          >
            {type} Routing Rule for {mid}
          </h5>
        </div>
        <Offcanvas.Body>
          <div className="overflow-x-scroll">
            <DndProvider backend={HTML5Backend}>
              <Table
                columns={columns}
                dataSource={data}
                components={components}
                pagination={false}
                onRow={(record, index) => ({
                  index,
                  moveRow,
                })}
                rowKey="prority"
              />
            </DndProvider>
            {!viewOnly && (
              <div>
                <button
                  className="badge badge-primary m-2 px-4 py-2"
                  onClick={updateRules}
                >
                  Update
                </button>
              </div>
            )}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default ShuffleRules;
